<template>
  <div>
    <b-row>
      <b-col cols="1">
        <b-img
          v-if="useCompanyInfo && companyLogoURL"
          v-bind="mainProps"
          :src="companyLogoURL"
          rounded
          style="object-fit: scale-down; margin-left: 15px;"
          alt="Rounded image"
        />
        <b-avatar
          v-if="carePlanImgURL"
          :src="carePlanImgURL"
          size="5em"
          style="margin-left: 25px;;"
          alt="Rounded image"
        />
      </b-col>
      <b-col>
        <h4>{{ firstname }} {{ lastname }}</h4>
        <p>
          Age: 88
        </p>
      </b-col>
      <b-col>
        <h3 v-if="age" :style="`margin-top:${topPxl};`">Age: {{ age }}</h3>
      </b-col>
      <b-col>
        <b-button
          pill
          block
          style="background:rgb(4,103,255); border:none"
          size="lg"
        >
          Generate
          <b-icon variant="light" icon="chevron-bar-right" />
        </b-button>
        <b-row style="margin-top:5px; margin-bottom:15px;">
          <b-col>
            <p style="margin-bottom:1px">5/9</p>
            <p>New Inquiries</p>
          </b-col>
          <b-col>
            <b-iconstack font-scale="2" style="margin-left:5px;">
              <b-icon
                stacked
                icon="printer"
                scale="0.5"
                variant="info"
              ></b-icon>
              <b-icon stacked icon="circle" variant="blue"></b-icon>
            </b-iconstack>
            <b-iconstack font-scale="2" style="margin-left:5px;">
              <b-icon
                stacked
                icon="printer"
                scale="0.5"
                variant="info"
              ></b-icon>
              <b-icon stacked icon="circle" variant="blue"></b-icon>
            </b-iconstack>
            <b-iconstack font-scale="2" style="margin-left:5px;">
              <b-icon
                stacked
                icon="printer"
                scale="0.5"
                variant="info"
              ></b-icon>
              <b-icon stacked icon="circle" variant="blue"></b-icon>
            </b-iconstack>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "CarePlan_HeaderProfile",
  components: {},
  props: {
    carePlan: {
      type: Object,
      default: () => {
        return {};
      }
    },
    profile: {
      type: Object,
      default: () => {
        return {};
      }
    },
    theme: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  mounted() {},
  data() {
    return {
      companyLogoURL:
        this.carePlan &&
        this.carePlan.plan &&
        this.carePlan.plan.company &&
        this.carePlan.plan.company.imgURL
          ? this.carePlan.plan.company.imgURL
          : null,
      useCompanyInfo:
        this.carePlan && this.carePlan.plan && this.carePlan.plan.useCompanyInfo
          ? this.carePlan.plan.useCompanyInfo
          : null,
      carePlanImgURL:
        this.carePlan && this.carePlan.plan && this.carePlan.plan.imgURL
          ? this.carePlan.plan.imgURL
          : null,
      firstname:
        this.carePlan &&
        this.carePlan &&
        this.carePlan.plan &&
        this.carePlan.plan.heartbeat &&
        this.carePlan.plan.heartbeat.firstname
          ? this.carePlan.plan.heartbeat.firstname
          : null,
      lastname:
        this.carePlan &&
        this.carePlan &&
        this.carePlan.plan &&
        this.carePlan.plan.heartbeat &&
        this.carePlan.plan.heartbeat.lastname
          ? this.carePlan.plan.heartbeat.lastname
          : null,
      relation:
        this.carePlan &&
        this.carePlan &&
        this.carePlan.plan &&
        this.carePlan.plan.fam &&
        this.carePlan.plan.fam.relationTo
          ? this.carePlan.plan.fam.relationTo
          : null,
      age: null,
      topPxl: "50px",
      heartbeatRelationship: null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 150,
        height: 150
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
